module.exports = __webpack_public_path__ + "static/media/Q5-9.a29c359b.jpg";